import { render, staticRenderFns } from "./repertPassward.vue?vue&type=template&id=5383d88a&"
import script from "./repertPassward.vue?vue&type=script&lang=js&"
export * from "./repertPassward.vue?vue&type=script&lang=js&"
import style0 from "./repertPassward.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports